module.exports = ".services-wrapper {\n  padding-top: 25px;\n  text-align: left; }\n"